/**
 * Configuration de l'interface, lue au DÉMARRAGE.
 *
 * En conteneur, elle vient de `/config.js`, régénéré au lancement : c'est ce
 * qui permet de promouvoir la même image de recette vers la production. En
 * développement, la variable Vite prend le relais.
 */
const runtime = window.__APP_CONFIG__ ?? {};

export const config = {
  API_BASE_URL: runtime.API_BASE_URL || import.meta.env.VITE_API_BASE_URL || '/api',
  ENVIRONNEMENT: runtime.ENVIRONNEMENT || 'local',
};
